import { object, string } from "yup"
const validationSchema = object().shape({
    batch: string().required("category is required"),
    preferredTranslationLanguage: string().required("Preferred Translation Language is required"),
})

export default validationSchema